export default __webpack_public_path__ + "static/media/Q3_2_resized.48ea28cd.jpg";